export const initialState = {
    approvalId:''
};

const ApprovalDetailReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_APPROVAL_ID':{
            return  {
                ...state,
                approvalId:action.value
            }
        }
        default:
            return state;
    }

};

export default ApprovalDetailReducer;
